import {ConfigSchema, OmicronConfigResponseType} from './types';

export const getDefaultConfig = <R extends Record<string, unknown>>(
  schema: ConfigSchema,
) => makeConfigSafe<R>(schema, {});

export const makeConfigSafe = <R extends Record<string, unknown>>(
  schema: ConfigSchema,
  config: Record<string, unknown>,
) => {
  const value = Object.entries(schema).reduce(
    (a, [key, {value: validator}]) => {
      const realValue = config[key];
      a[key] = validator.is(realValue) ? realValue : validator.fallback;
      return a;
    },
    {} as Record<string, unknown>,
  );
  return value as R;
};

export const makeResponseSafe = <R extends Record<string, unknown>>(
  schema: ConfigSchema,
  response: OmicronConfigResponseType<R>,
): OmicronConfigResponseType<R> => ({
  ...response,
  config: makeConfigSafe(schema, response.config || {}),
});
